import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Collapse from 'react-smooth-collapse';

var Accordion = function Accordion(props) {
  var customOpen = props.customOpen,
      defaultOpen = props.defaultOpen,
      onClose = props.onClose,
      title = props.title,
      children = props.children,
      style = props.style,
      headerStyle = props.headerStyle,
      bodyStyle = props.bodyStyle,
      className = props.className,
      onHeaderClick = props.onHeaderClick;
  var initialOpen = customOpen || defaultOpen;

  var _useState = useState(initialOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  useEffect(function () {
    if (!open) {
      onClose && onClose();
    }
  }, [onClose, open]);

  var onLocalHeaderClick = function onLocalHeaderClick(event) {
    setOpen(function (prevOpen) {
      return !prevOpen;
    });
    onHeaderClick(event, open);
  };

  useEffect(function () {
    setOpen(customOpen || defaultOpen);
  }, [customOpen, defaultOpen]);
  return React.createElement("div", {
    className: "accordion".concat(open ? ' accordion-open ' : ' ').concat(className),
    style: style
  }, React.createElement("div", {
    className: "accordion-header",
    onClick: onLocalHeaderClick,
    style: headerStyle
  }, React.createElement("div", {
    className: "accordion-arrow"
  }, React.createElement("i", {
    className: "fa fa-lg fa-angle-".concat(open ? 'down' : 'right')
  })), title), React.createElement(Collapse, {
    expanded: open
  }, React.createElement("div", {
    className: "accordion-body",
    style: bodyStyle
  }, children)));
};

Accordion.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  defaultOpen: PropTypes.bool,
  customOpen: PropTypes.bool,
  style: StylePropType,
  headerStyle: StylePropType,
  bodyStyle: StylePropType,
  className: PropTypes.string,
  onHeaderClick: PropTypes.func,
  onClose: PropTypes.func
};
Accordion.defaultProps = {
  defaultOpen: false,
  onHeaderClick: function onHeaderClick() {
    return undefined;
  },
  style: {},
  headerStyle: {},
  bodyStyle: {},
  className: ''
};
export default Accordion;